/**
 * Copyright Fitzba Technologies Inc. 2023
 * The NearProducts component fetches and displays a list of products that are near the user's location.
 * 
 * Each product is displayed as an Item component.
 * 
 * The component uses the useQuery hook from react-query for data fetching
 * and the useSelector hook from react-redux to get the user's location and information.
 * 
 * The component also provides a horizontal scrolling feature for the list of products.
 *
 * @author Yang Ming
 * @version June 5th, 2023
 */


import React from 'react'
import { getStoreServiceList } from '@services/api.business.service'
import { useQuery } from '@tanstack/react-query'
import ServiceCard from './ServiceCard'
import ServiceCardImage from './ServiceCardImage'
import SectionTitle from './SectionTitle'
import { serviceBookNow } from '@services/api.business.service'
import ServiceProviders from './ServiceProviders'

export default function ServiceList({
    business,
    isMobile,
    selectedCategory
}) {

    const [isOpen, setIsOpen] = React.useState(false)
    const [providers, setProviders] = React.useState([])
    const [selectedService, setSelectedService] = React.useState(null)

    const {
        isPending,
        // error,
        data,
    } = useQuery({
        queryKey: ['getStoreServiceList', business?._id, selectedCategory],
        queryFn: () => getStoreServiceList({
            business_id: business?._id,
            category_id: selectedCategory
        }),
    })

    if (isPending) return null

    const services = data?.data || []
    const category = data?.category || null
    console.log('Category11', category)
    console.log('ServiceList', services)

    if (services.length === 0) return null

    async function handleBookNow(service_id) {
        try {
            const res = await serviceBookNow({
                business_id: business?._id,
                service_id: service_id
            })
            const result = res?.data
            setSelectedService(res?.data)
            if (result?.book_url) {
                // window.open(result?.book_url, '_blank')
                // window.location.href = result?.book_url

                // 创建并触发一个 <a> 标签跳转
                const link = document.createElement('a')
                link.href = result?.book_url
                link.target = '_blank'
                link.rel = 'noopener noreferrer'
                link.click()

                return
            }
            if (result?.providers && result?.providers.length > 0) {
                setProviders(result?.providers)
                setIsOpen(true)
                return
            }
            console.log('ServiceList handleBookNow', res)
        } catch (err) {
            console.log('ServiceList handleBookNow', err)
        }
    }

    return (
        <section className="w-full m-auto flex flex-col" id='service-list'>
            <ServiceProviders
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                providers={providers}
                selectedService={selectedService}
            />
            {/* <SectionTitle title={'Services'} /> */}
            {services.length === 0 && <div className="text-center">No Services Available</div>}
            <div className='mb-5 flex flex-col gap-3'>
                {category?.image &&
                    <img src={category?.image} alt={category?.title} className='w-full h-[400px] object-cover rounded-lg' />
                }
                <h3 className='text-[32px] font-medium'>{category?.parent ? `${category?.parent?.title} - ` : ''} {category?.title}</h3>
                <p dangerouslySetInnerHTML={{ __html: category?.description }}></p>
            </div>
            <div className="w-full h-auto flex gap-10 text-left smsize:gap-3 flex-wrap">
                {services.map((service, index) => {
                    if (service?.image) {
                        return <ServiceCardImage key={index} service={service} />
                    }
                    return <ServiceCard
                        key={index}
                        service={service}
                        handleBookNow={handleBookNow}
                    />
                })}
            </div>
        </section>
    )
}
